import { useNavigate } from 'react-router-dom'
import { Sparkles } from 'lucide-react'
import { Button } from '@loop3/ui'

/** Opens Lupe with `question` prefilled and sent. */
export function AskLupeButton({
  question,
  label = 'Ask Lupe',
}: {
  question: string
  label?: string
}) {
  const navigate = useNavigate()
  return (
    <Button
      variant="outline"
      size="sm"
      title={question}
      onClick={() => navigate('/?ask=' + encodeURIComponent(question))}
    >
      <Sparkles className="text-[var(--l3-violet)]" aria-hidden />
      {label}
    </Button>
  )
}
